export function getReferencePackLicenseLabel(license: string | null | undefined): string | null {
  if (!license) return null;

  switch (license) {
    case 'personal_reference':
      return 'Artist reference license';
    case 'classroom_reference':
      return 'Classroom reference license';
    default:
      return license.replaceAll('_', ' ');
  }
}
